import { useQuery, type QueryKey } from '@tanstack/react-query';
import tasksService, { type UserTasksParams } from '@/api/services/tasks';

export const getUserTasksQueryKey = ({ status, groupId }: UserTasksParams = {}) =>
  ['user-tasks']
    .concat(status ? [String(status)] : [])
    .concat(groupId ? [String(groupId)] : []) as QueryKey;

export const useGetUserTasks = (params?: UserTasksParams) => {
  return useQuery({
    queryKey: getUserTasksQueryKey(params),
    queryFn: ({ signal }) => tasksService.getUserTasks(params, signal),
    select: (res) => {
      const items = (res?.data ?? []).slice();
      items.sort((a, b) => {
        const byCreated = (b.createdAt ?? 0) - (a.createdAt ?? 0);
        if (byCreated !== 0) return byCreated;
        return (a.title || '').localeCompare(b.title || '');
      });
      return { ...res, data: items };
    },
  });
};
